import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import MoreAboutGaruda from "../../../images/AboutGaruda.svg";
import SectionTitle from "../../../components/SectionTitle";
import { Box, Hidden } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ExploreMoreButton } from "../../../components/ExploreMoreButton/ExploreMoreButton";
import styles from "./css/AboutGarudaPlatform.module.css";
import { Routes } from "../../../routes/routes";

export default function AboutGarudaPlatform() {
  const navigate = useNavigate();
  const handleLearnMore = () => navigate(Routes.ABOUT_PLATFORM);

  return (
    <Box className={styles.cardContainer}>
      <Hidden mdDown>
        <img src={MoreAboutGaruda} alt={"More about Garuda"}></img>
      </Hidden>
      <Box className={styles.cardContentContainer}>
        <CardContent className={styles.cardContent}>
          <SectionTitle
            dataTestId="learn-more-about-garuda"
            value="GARUDA 2x - A revamped experience"
          />
          <Typography
            data-testid="learn-more-about-garuda-desc"
            variant="body1"
            gutterBottom
          >
            Garuda2x is the ultimate destination for exploring, installing, and managing cutting-edge agents. 
            Whether you are navigating healthcare solutions or unlocking biological insights; Garuda2x empowers 
            you to seamlessly integrate, discover, and innovate all from a single, powerful platform.
          </Typography>
          <Hidden smDown>
            <Typography variant="body2" sx={{fontWeight:"bold"}}>
              Start your journey today and experience the power of Garuda2x!
            </Typography>
          </Hidden>
        </CardContent>
        <CardActions>
          <ExploreMoreButton label="Know more about Garuda2x" dataTestId="learn-more-about-garuda-btn" clickHandler={handleLearnMore}/>
        </CardActions>
      </Box>
    </Box>
  );
}
